import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {ComandaClienteService} from '../../services/comanda-cliente.service';
import {CarrinhoService} from '../../services/carrinho.service';
import {DominiosService} from '../../services/dominios.service';
import {ITela} from '../../objeto/ITela';

@Component({
  selector: 'app-minha-comanda',
  templateUrl: './minha-comanda.component.html',
  styleUrls: ['./minha-comanda.component.scss']
})
export class MinhaComandaComponent implements OnInit, OnDestroy, ITela {
  comanda: any;
  pagamento: any;
  carregando = true;
  gerando = false;
  sincronizando = false;
  cancelando = false;
  confirmandoPagamento = false;
  pixCopiado = false;
  pixExpirado = false;
  sucesso = false;
  erro: string;
  aviso: string;
  nomeCliente = '';
  segundosRestantes = 0;
  private intervaloContador: any;
  private intervaloSincronizacao: any;

  constructor(private comandaService: ComandaClienteService,
              private carrinhoService: CarrinhoService,
              private dominiosService: DominiosService,
              private clipboard: Clipboard) {}

  ngOnInit(): void {
    this.carregueConta();
  }

  ngOnDestroy(): void {
    this.pareMonitoramento();
  }

  deveExibirTopo(): boolean {
    return false;
  }

  deveExibirMenu(): boolean {
    return false;
  }

  deveTerBordas(): boolean {
    return false;
  }

  deveExibirBannerTema(): boolean {
    return false;
  }

  @HostListener('document:visibilitychange')
  aoAlterarVisibilidade(): void {
    if(!document.hidden && this.pagamento && !this.sucesso) this.sincronizePagamento(true);
  }

  carregueConta(): void {
    this.carregando = true;
    this.erro = null;
    this.comandaService.obtenhaMinhaComanda(this.carrinhoService.obtenhaPedido()).then((comanda: any) => {
      this.apliqueComanda(comanda);
      this.carregando = false;
    }).catch((erro: any) => {
      this.erro = String(erro || 'Não foi possível carregar sua conta.');
      this.carregando = false;
    });
  }

  abraConfirmacao(): void {
    this.aviso = null;
    this.nomeCliente = this.comanda?.nomeCliente || this.carrinhoService.obtenhaPedido()?.contato?.nome || '';
    this.confirmandoPagamento = true;
  }

  fecheConfirmacao(): void {
    if(!this.gerando) this.confirmandoPagamento = false;
  }

  gerePix(): void {
    const nome = String(this.nomeCliente || '').trim();
    if(!nome) {
      this.aviso = 'Informe seu nome para identificar o pagamento.';
      return;
    }

    this.gerando = true;
    this.aviso = null;
    this.comandaService.gerePix(nome, this.comanda.saldoPagar).then((resultado: any) => {
      this.confirmandoPagamento = false;
      this.gerando = false;
      this.comanda = resultado.comanda;
      this.pagamento = resultado.pagamento || this.comanda.pagamentoPixPendente;
      this.inicieMonitoramento();
    }).catch((erro: any) => {
      this.aviso = String(erro || 'Não foi possível gerar o Pix. Tente novamente.');
      this.gerando = false;
      if(this.aviso.indexOf('conta foi atualizada') >= 0) {
        this.confirmandoPagamento = false;
        this.carregueConta();
      }
    });
  }

  copiePix(): void {
    if(!this.pagamento?.codigoQrCode) return;
    this.pixCopiado = this.clipboard.copy(this.pagamento.codigoQrCode);
    if(this.pixCopiado) setTimeout(() => this.pixCopiado = false, 3500);
  }

  obtenhaUrlQrCode(): string {
    const codigoQrCode = this.pagamento?.codigoQrCode;
    return codigoQrCode ? '/api/qrcode?c=' + encodeURIComponent(codigoQrCode) : '';
  }

  sincronizePagamento(forcar = false): void {
    if(!this.pagamento || this.sincronizando || this.sucesso) return;
    this.sincronizando = true;
    this.comandaService.sincronizePix(this.pagamento, forcar).then((resultado: any) => {
      this.sincronizando = false;
      this.apliqueComanda(resultado.comanda);
    }).catch(() => {
      this.sincronizando = false;
      this.aviso = 'Sem conexão para conferir agora. Continuaremos tentando automaticamente.';
    });
  }

  cancelePix(): void {
    if(!this.pagamento || this.cancelando) return;
    this.cancelando = true;
    this.comandaService.cancelePix(this.pagamento).then((resultado: any) => {
      this.cancelando = false;
      this.pagamento = null;
      this.pixExpirado = false;
      this.pareMonitoramento();
      this.apliqueComanda(resultado.comanda);
    }).catch((erro: any) => {
      this.cancelando = false;
      this.aviso = String(erro || 'Não foi possível cancelar este Pix.');
      this.pareMonitoramento();
      this.pagamento = null;
      this.pixExpirado = false;
      this.carregueConta();
    });
  }

  volteParaConta(): void {
    if(this.pagamento?.cancelamentoDisponivel) {
      this.cancelePix();
      return;
    }

    this.pagamento = null;
    this.pixExpirado = false;
    this.pareMonitoramento();
    this.carregueConta();
  }

  soliciteGarcom(): void {
    this.aviso = null;
    this.carrinhoService.soliciteFecharMesa().then(() => {
      this.aviso = 'Pedido de fechamento enviado. O garçom já foi avisado.';
    });
  }

  volteAoCardapio(): void {
    this.dominiosService.vaParaHome();
  }

  conclua(): void {
    this.carrinhoService.sairDaMesaParaDelivery();
    this.dominiosService.vaParaHome();
  }

  formateTempo(): string {
    const minutos = Math.floor(this.segundosRestantes / 60);
    const segundos = this.segundosRestantes % 60;
    return `${minutos}:${segundos < 10 ? '0' : ''}${segundos}`;
  }

  pagamentosConfirmados(): any[] {
    return (this.comanda?.pagamentos || []).filter((pagamento: any) =>
      Number(pagamento.statusNumero) === 0 || Number(pagamento.statusNumero) === 3);
  }

  private apliqueComanda(comanda: any): void {
    this.comanda = comanda;
    this.nomeCliente = this.nomeCliente || comanda?.nomeCliente || '';
    if(comanda?.fechada) {
      this.sucesso = true;
      this.pagamento = null;
      this.pareMonitoramento();
      return;
    }

    const pagamentoPendente = comanda?.pagamentoPixPendente;
    if(pagamentoPendente) {
      this.pagamento = pagamentoPendente;
      this.inicieMonitoramento();
    } else if(this.pagamento) {
      const pagamentoAtual = (comanda?.pagamentos || []).find((item: any) => Number(item.id) === Number(this.pagamento.id));
      if(pagamentoAtual && [4, 7, 9].indexOf(Number(pagamentoAtual.statusNumero)) >= 0) {
        this.pixExpirado = true;
        this.pareMonitoramento();
      }
    }
  }

  private inicieMonitoramento(): void {
    this.pareMonitoramento();
    this.atualizeContador();
    this.intervaloContador = setInterval(() => this.atualizeContador(), 1000);
    this.intervaloSincronizacao = setInterval(() => this.sincronizePagamento(), 5000);
  }

  private atualizeContador(): void {
    const expiracao = this.pagamento?.dataExpiracao ? new Date(this.pagamento.dataExpiracao).getTime() : 0;
    this.segundosRestantes = Math.max(0, Math.ceil((expiracao - Date.now()) / 1000));
    if(this.segundosRestantes === 0 && !this.pixExpirado) {
      this.pixExpirado = true;
      this.sincronizePagamento(true);
    }
  }

  private pareMonitoramento(): void {
    if(this.intervaloContador) clearInterval(this.intervaloContador);
    if(this.intervaloSincronizacao) clearInterval(this.intervaloSincronizacao);
    this.intervaloContador = null;
    this.intervaloSincronizacao = null;
  }
}
